import { aboutData } from '@/mocks/movies';

export default function About() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-8">
            {aboutData.title}
          </h2>

          <div className="space-y-4">
            {aboutData.paragraphs.map((p, i) => (
              <p
                key={i}
                className="text-sm md:text-base text-foreground-700 leading-relaxed"
              >
                {p}
              </p>
            ))}
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mt-10 pt-8 border-t border-background-200/70">
            <div className="text-center">
              <div className="font-heading text-2xl md:text-3xl font-black text-primary-600">10万+</div>
              <div className="text-xs md:text-sm text-foreground-600 mt-1">电影资源</div>
            </div>
            <div className="text-center">
              <div className="font-heading text-2xl md:text-3xl font-black text-accent-600">1000万+</div>
              <div className="text-xs md:text-sm text-foreground-600 mt-1">注册用户</div>
            </div>
            <div className="text-center">
              <div className="font-heading text-2xl md:text-3xl font-black text-primary-600">50+</div>
              <div className="text-xs md:text-sm text-foreground-600 mt-1">每日更新</div>
            </div>
            <div className="text-center">
              <div className="font-heading text-2xl md:text-3xl font-black text-accent-600">0</div>
              <div className="text-xs md:text-sm text-foreground-600 mt-1">广告骚扰</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}